import { render, staticRenderFns } from "./specialPriceApplyHistory.vue?vue&type=template&id=388666cc&scoped=true"
import script from "./specialPriceApplyHistory.vue?vue&type=script&lang=js"
export * from "./specialPriceApplyHistory.vue?vue&type=script&lang=js"
import style0 from "./specialPriceApplyHistory.vue?vue&type=style&index=0&id=388666cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388666cc",
  null
  
)

export default component.exports